export const programsData = [
  {
    id: "corporate",
    title: "Corporate Programs",
    icon: "FaBriefcase", // Icon placeholder
    summary: "Empowering teams and leadership for vibrant organizational energy.",
    details: {
      mode: "In person or Online",
      audience: [
        "Leadership Teams",
        "Supervisory Teams",
        "Frontline Employees",
        "Service Providers",
        "Facility Care employees"
      ],
      duration: "90 minutes to 3 Days",
      modules: "5 to 12 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Presentations",
        "Interactive Discussions",
        "Case Studies",
        "Physical & Mental Therapies",
        "Aesthetic Engagements",
        "Group Activities",
        "Food & Dietary Regimes",
        "Philosophical Dialogues",
        "Common Sense Awakening"
      ]
    }
  },
  {
    id: "child",
    title: "Child Programs",
    icon: "FaChild",
    summary: "Nurturing the natural vibrancy of children and youth.",
    details: {
      mode: "In person or Online",
      audience: [
        "Children (10-15)",
        "Adolescents",
        "Youth Groups",
        "Children with Special Conditions (Mental Distress, Emotional Conditions)"
      ],
      duration: "3 Hours to 3 Days",
      modules: "5 to 8 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Mock Exercise & Role Plays",
        "Presentations",
        "Interactive Discussions",
        "Physical & Mental Therapies (Age Appropriate)",
        "Aesthetic Engagements",
        "Group Activities",
        "Food & Dietary Regimes",
        "Philosophical Dialogues (Child Moral Stories)",
        "Common Sense Awakening"
      ]
    }
  },
  {
    id: "partners",
    title: "Committed Life Partners",
    icon: "FaHeart",
    summary: "Strengthening bonds and shared vibrancy for couples.",
    details: {
      mode: "In person or Online",
      audience: [
        "Romantic Partners",
        "Committed Partners",
        "Marital & Wedded Couples",
        "Life Partners",
        "Long-term Partners"
      ],
      duration: "1 Day to 3 Days",
      modules: "3 to 5 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Interactive Discussions",
        "Physical & Mental Therapies",
        "Mock Exercise & Role Plays",
        "Aesthetic Engagements",
        "Group Activities",
        "Food & Dietary Regimes",
        "Relaxation & Breathing",
        "Soft Physical Movement",
        "Philosophical Dialogues"
      ]
    }
  },
  {
    id: "women",
    title: "Programs for Women",
    icon: "FaFemale",
    summary: "Empowering women to navigate life's challenges with energy.",
    details: {
      mode: "In person or Online",
      audience: [
        "Young Women",
        "Single Parents",
        "Women in Singlehood",
        "Women experiencing any Life Challenge"
      ],
      duration: "1 Day to 3 Days",
      modules: "3 to 5 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Interactive Discussions",
        "Physical & Mental Therapies",
        "Mock Exercise & Role Plays",
        "Aesthetic Engagements",
        "Circles",
        "Food & Dietary Regimes",
        "Relaxation & Breathing",
        "Soft Physical Movement",
        "Philosophical Dialogues"
      ]
    }
  },
  {
    id: "men",
    title: "Programs for Men",
    icon: "FaMale",
    summary: "Guiding men toward balance, clarity, and purpose.",
    details: {
      mode: "In person or Online",
      audience: [
        "Young Men",
        "Single Parents (Fathers)",
        "Men in Singlehood",
        "Men experiencing any Life Challenge"
      ],
      duration: "1 Day to 3 Days",
      modules: "3 to 5 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Interactive Discussions",
        "Physical & Mental Therapies",
        "Mock Exercise & Role Plays",
        "Aesthetic Engagements",
        "Group Activities",
        "Food & Dietary Regimes",
        "Relaxation & Breathing",
        "Soft Physical Movement",
        "Philosophical Dialogues"
      ]
    }
  },
  {
    id: "senior",
    title: "Senior Citizens",
    icon: "FaBlind",
    summary: "Enhancing vitality and peace in the golden years.",
    details: {
      mode: "In person or Online",
      audience: [
        "Senior Citizens",
        "Adult Groups (age 50+)"
      ],
      duration: "1 Day to 3 Days",
      modules: "3 to 5 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Interactive Discussions",
        "Physical & Mental Therapies (Age Appropriate)",
        "Mock Exercise & Role Plays",
        "Aesthetic Engagements",
        "Group Activities",
        "Food & Dietary Regimes",
        "Relaxation & Breathing",
        "Soft Physical Movement",
        "Philosophical Dialogues (Senior's Moral Stories)"
      ]
    }
  },
  {
    id: "general",
    title: "For Any Human",
    icon: "FaUser",
    summary: "Universal programs for anyone seeking a vibrant life.",
    details: {
      mode: "In person or Online",
      audience: [
        "Any human who wants to get vibrant life",
        "Any human who experiences any Life Challenge"
      ],
      duration: "1 Day to 3 Days",
      modules: "3 to 5 Modules",
      modality: [
        "Self Assessments & Reflections",
        "Interactive Discussions",
        "Physical & Mental Therapies",
        "Mock Exercise & Role Plays",
        "Aesthetic Engagements",
        "Group Activities",
        "Food & Dietary Regimes",
        "Relaxation & Breathing",
        "Soft Physical Movement",
        "Philosophical Dialogues"
      ]
    }
  }
];